module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "regional-offices"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.title) ? _c('div', {
    class: ['row', 'key-contact', _vm.sub_class]
  }, [_c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12"
  }, [(_vm.title) ? _c('div', {
    staticClass: "our-location__label"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "location-list"
  }, [_c('ul', _vm._l((_vm.offices), function(office, i) {
    return _c('li', {
      key: i,
      staticClass: "location-list__item",
      class: {
        'location-list__item--active': _vm.activeOffice === i
      },
      on: {
        "click": function($event) {
          return _vm.setActiveOffice(i, office.city_slug)
        }
      }
    }, [_c('span', {
      staticClass: "location-list__item-text"
    }, [_vm._v(_vm._s(office && office.city))]), _vm._v(" "), (_vm.activeOffice === i) ? _c('span', {
      staticClass: "location-list__item-arrow"
    }) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', _vm._l((_vm.offices), function(office, i) {
    return (_vm.offices) ? _c('div', [(_vm.activeOffice === i) ? _c('p', {
      staticClass: "annotation"
    }, [_vm._v("\n                " + _vm._s(office && office.annotation) + "\n              ")]) : _vm._e()]) : _vm._e()
  }), 0)])]), _vm._v(" "), (_vm.offices[this.activeOffice]) ? _c('div', {
    staticClass: "location-details col-l-4 col-m-4 col-s-12"
  }, [(_vm.offices[this.activeOffice]) ? _c('div', {
    staticClass: "our-location__adress",
    domProps: {
      "innerHTML": _vm._s(_vm.offices[this.activeOffice].adress)
    }
  }) : _vm._e(), _vm._v(" "), (
    _vm.offices[this.activeOffice] &&
    !_vm.offices[this.activeOffice].button_adress_display
  ) ? _c('div', {
    staticClass: "our-location__button"
  }, [_c('router-link', {
    attrs: {
      "active-class": "active",
      "to": '/' + _vm.slug + '/' + _vm.offices[this.activeOffice].city_slug
    }
  }, [_c('div', {
    staticClass: "btn default"
  }, [_c('span', {
    staticClass: "our-location__button-text",
    domProps: {
      "innerHTML": _vm._s(_vm.offices[this.activeOffice].button_adress_label)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "our-location__button-arrow"
  })])])], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12 our-location__map"
  }, [(_vm.offices[_vm.activeOffice] && _vm.offices[_vm.activeOffice].map_link) ? _c('iframe', {
    attrs: {
      "src": _vm.offices[_vm.activeOffice].map_link,
      "width": "100%",
      "height": "340",
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen"
    }
  }) : _vm._e()])]) : _c('div', [_c('div', {
    staticClass: "be-contact-map"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row mb-50"
  }, [_c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12"
  }, [_c('div', {
    staticClass: "location location-info"
  }, [(_vm.bedata.title) ? _c('h2', {
    staticClass: "location-info__title",
    domProps: {
      "innerHTML": _vm._s(_vm.bedata.title)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bedata.adress) ? _c('div', {
    staticClass: "location-info__adress",
    domProps: {
      "innerHTML": _vm._s(_vm.bedata.adress)
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12"
  }, [_c('div', {
    staticClass: "location location-person"
  }, [_c('div', {
    staticClass: "location-person__image"
  }, [(_vm.bedata.photo) ? _c('img', {
    attrs: {
      "src": _vm.bedata.photo.url,
      "alt": "photo"
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "location-person__info"
  }, [_c('div', {
    staticClass: "location-person__name"
  }, [_vm._v(_vm._s(_vm.bedata.name))]), _vm._v(" "), _c('div', {
    staticClass: "location-person__position"
  }, [_vm._v("\n                    " + _vm._s(_vm.bedata.position) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "location-person__email"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.bedata.email
    }
  }, [_vm._v(_vm._s(_vm.bedata.email))])]), _vm._v(" "), _c('div', {
    staticClass: "location-person__phone"
  }, [_c('a', {
    attrs: {
      "href": 'tel:' + _vm.bedata.phone
    }
  }, [_vm._v(_vm._s(_vm.bedata.phone))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-l-4 col-m-4 col-s-12"
  }, [_c('div', {
    staticClass: "location location-map"
  }, [_c('iframe', {
    staticClass: "location-map__iframe",
    staticStyle: {
      "border": "0"
    },
    attrs: {
      "src": _vm.bedata.map_link,
      "width": "100%",
      "height": "340",
      "frameborder": "0",
      "allowfullscreen": "allowfullscreen"
    }
  })])])]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "form-wrapper",
    domProps: {
      "innerHTML": _vm._s(_vm.bedata.contact_form)
    }
  })])])])]), _vm._v(" "), _vm._l((_vm.blocks), function(block, index) {
    return [_c(block.acf_fc_layout, {
      key: index,
      tag: "component",
      attrs: {
        "blockdata": block,
        "city_title": _vm.city_title,
        "cities": _vm.cities
      }
    })]
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9eb2a874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegionalOffices.vue
// module id = 357
// module chunks = 0